module.exports = __webpack_public_path__ + "media/images/pc/specials/common/recommend_kobe-dedf82b1cd1af33068160ea89635585e.jpg";